import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useTimesheetProvider } from "../../../../../Providers/Vendor/Timesheet";
import Daywise from "./Timesheet/Daywise";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import Back from "../../../../../Components/Back";
import CustomTable from "../../../../../Components/Table";
import CryptoJS from "crypto-js";

const headCells = [
  { disablePadding: false, label: "Job" },
  { disablePadding: false, label: "Week" },
  { disablePadding: false, label: "Submitted On" },
  { disablePadding: false, label: "Consultant" },
  { disablePadding: false, label: "Status" },
  { disablePadding: false, label: "Total Hours" },
  { disablePadding: false, label: "" },
];

export default function Timesheet({ setCard }) {
  const { token } = useParams();
  const { id } = useParams()
  const [loading, setLoading] = useState(true);

  const {
    timesheets,
    fetchTimesheets,
    selectedTimesheet,
    setSelectedTimesheet,
    getTimesheetIdFromLink
  } = useTimesheetProvider();

  useEffect(() => {
    fetchTimesheets();
  }, []);

  const navigate = useNavigate()

  useEffect(() => {
    if (token) {
      const secret = "rJK7?E@KynQ!5F39C-gy";
      const wordArray = CryptoJS.enc.Base64url.parse(token);
      const string = wordArray.toString(CryptoJS.enc.Base64);
      const bytes = CryptoJS.AES.decrypt(string, secret);
      const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      getTimesheetIdFromLink(data.linkId).then(() => setLoading(false));
    }
  }, [token]);

  useEffect(() => {
    if (id) {
      setSelectedTimesheet(id)
    }
  }, [id])

  const CustomRow = ({ row }) => {
    return (
      <TableRow hover tabIndex={-1} key={row.id}>
        <TableCell align="left">{row?.job?.name}</TableCell>
        <TableCell align="left">
          {moment.utc(row.start).format("DD/MM/YY")} -{" "}
          {moment.utc(row.end).format("DD/MM/YY")}
        </TableCell>
        <TableCell align="left">
          {moment.utc(row.updatedAt).format("DD/MM/YY")}
        </TableCell>
        <TableCell align="left">
          {row.consultant?.firstName} {row.consultant?.lastName}
        </TableCell>
        <TableCell align="left">
          {row.status[0] + row.status.slice(1).toLowerCase()}
        </TableCell>
        <TableCell align="left">
          {row.hours.toString().padStart(2, "0")}:
          {row.minutes.toString().padStart(2, "0")}
        </TableCell>
        <TableCell align="left">
          <button
            className="text-blue-400 px-2 py-1 rounded-md"
            onClick={() => {
              navigate(`/dashboard/timesheetscard/${row.id}`)
            }}
          >
            View Details
          </button>
        </TableCell>
      </TableRow>
    );
  };
  return selectedTimesheet === null ? (
    <>
      <Back onClick={() => {
        navigate("/dashboard")
      }} />
      <CustomTable
        title="Timesheet"
        headCells={headCells}
        rows={timesheets}
        CustomRow={CustomRow}
      />
    </>
  ) : (
    <Daywise />
  );
}
